import { expVal } from '@atlassian/jira-feature-experiments';

/**
 * This helper guards code that is meant to be visible for M0 and onwards.
 */
export const isProjectsInJiraM0Enabled = () => {
	if (expVal('atlassian_projects_-_native_integration', 'releaseVersion', 0) >= 0) {
		return true;
	}
	return false;
};

/**
 * This helper guards code that is meant to be visible for M1 and onwards.
 */
export const isProjectsInJiraM1Enabled = () => {
	if (expVal('atlassian_projects_-_native_integration', 'releaseVersion', 0) >= 1) {
		return true;
	}
	return false;
};

/**
 * This helper guards code that is meant to be visible for M2.
 */
export const isProjectsInJiraM2Enabled = () => {
	if (expVal('atlassian_projects_-_native_integration', 'releaseVersion', 0) >= 2) {
		return true;
	}
	return false;
};
